import React from "react";
import { useState } from "react";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const inputHeight = "44px";
const textInputStyle = { height: inputHeight, borderRadius: "4px" };
export const displayExtensionDay = (extensionDays, ticketId) => {
   console.log(extensionDays, ticketId, "displayExtensionDay")

  return (<div style={{ display: "flex", flexDirection: "column" }}>
      <span className="text-bold" style={{ fontSize: "14px", color: "#0F0F0F" }}>
        Extension Days: {extensionDays}
      </span>
      <span className="text-bold" style={{ fontSize: "14px", color: "#0F0F0F" }}>
        Ticket ID: {ticketId}
      </span>
    </div>
  );
};
const ShowDetailRowDetails = ({ row }) => {
  return (
    <div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>Company code</div>
        <div className="text-dark text-bold">{row?.companyCode?.label}</div>
      </div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>Business Area</div>
        <div className="text-dark text-bold">{row?.businessArea?.label}</div>
      </div>
      <div className="d-flex justify-content-between regular-body mb-2">
        <div>Academic career </div>
        <div className=" text-dark text-bold">
          {" "}
          {row?.academicCareer?.label}
        </div>
      </div>
    </div>
  );
};

const CaptureForm = ({ form, rowFormHandler }) => {
  return (
    <div style={{ minWidth: "300px" }}>
      <AInput
        value={form?.activeDays}
        label="Enter extension days"
        style={textInputStyle}
        minLength={1}
        maxLength={3}
        type="number"
        placeholder="Enter number of days"
        handler={(value) => rowFormHandler(value, "activeDays")}
      />

      <AInput
        value={form?.ticketId}
        label="Ticket ID"
        style={textInputStyle}
        minLength={1}
        maxLength={20}
        placeholder="Enter ticket ID"
        handler={(value) => rowFormHandler(value, "ticketId")}
      />
    </div>
  );
};
const DateExtensionCaptureDialog = ({
  form,
  row,
  rowFormHandler,
  saveHandler,
  closeModal
}) => {
  console.log(form, "form")
  const [currentForm, setCurrentForm] = useState({
    activeDays: form?.activeDays,
    ticketId: form?.ticketId
  });
  const formHandler = (value, key) => {
    if(key === "activeDays" && value > 999) return ;
    setCurrentForm((prev) => ({
      ...prev,
      [key]: value
    }));
  };
  const saveHandlerWrapper = () => {
    if(!currentForm?.activeDays || !currentForm?.ticketId) return ; 
    saveHandler(currentForm);
    closeModal();
  }
  return (
    <div>
      <ShowDetailRowDetails row={row} />
      <CaptureForm form={currentForm} rowFormHandler={formHandler} />
      <AButton
        onClick={saveHandlerWrapper}
        updatedStyle={{ width: "100%", marginTop: "20px" }}
        variant="primary_filled"
        className="button_remove_left_margin"
        disabled={!currentForm?.activeDays || !currentForm?.ticketId}
      >
        Save
      </AButton>
    </div>
  );
};

export default DateExtensionCaptureDialog;
